import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, computed, ElementRef, effect, forwardRef, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { GuidelineService } from 'shared/domain';
import { ButtonDirective } from 'shared/ui-common';
import { OrganisationSettingsService } from 'shared/util-common';

import { ColorCustomisationsDirective, CssVariableService } from '@treetop/shared/color-presets';
import { FlowchartNodeType } from '@treetop/shared/model';

import { FlowchartComponent } from '../../flowchart.component';

export type FlowchartDialogData = {
  flowchartElements: FlowchartNodeType[];
  id: string;
};

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-flowchart-dialog',
  templateUrl: './flowchart-dialog.component.html',
  styleUrls: ['./flowchart-dialog.component.scss'],
  imports: [TranslocoPipe, forwardRef(() => FlowchartComponent), ButtonDirective, ColorCustomisationsDirective],
})
export class FlowchartDialogComponent {
  protected dialogRef = inject(DialogRef);
  private guidelineService = inject(GuidelineService, { optional: true });
  private organisationSettingsService = inject(OrganisationSettingsService);
  protected organisationSettings = computed(
    () => this.guidelineService?.guidelineData()?.organisation?.organisationSettings ?? this.organisationSettingsService.settings(),
  );

  protected data = inject<FlowchartDialogData>(DIALOG_DATA);

  private cssVariableService = inject(CssVariableService);
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  constructor() {
    effect(() => {
      const colorPresets = this.organisationSettings().customisations?.colorPresets;
      if (colorPresets) {
        this.cssVariableService.setColorPresets(colorPresets, this.elementRef.nativeElement);
      }
    });
  }
}
